import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';

import { VisitorUpfrontRegistrationFilterComponent } from './component/visitor-upfront-registration-filter.component';
import { CommonLayoutModule } from '@sdbn/common';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    VisitorUpfrontRegistrationFilterComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,
    MatTooltipModule

  ],
  exports: [
    VisitorUpfrontRegistrationFilterComponent
  ]
})
export class VisitorUpfrontRegistrationFilterModule { }
